module.exports = __webpack_public_path__ + "img/partner_icon22.0e6019e0.png";